<div>
  @if (showClientFileManagerCheckbox) {
    <div class="row align-items-center mb-2 mt-2">
      <div class="col-auto">
        <input type="checkbox" [(ngModel)]="openClientFileManager" id="openClientFileManager" [disabled]="isClientFileManagerDisabled">
      </div>
      <div class="col">
        <label for="openClientFileManager" class="mb-0" [class.disabled-label]="isClientFileManagerDisabled">Enable Client File Manager</label>
      </div>
    </div>
  }
  <div class="_wf-historyheading-epricription mb-3">
    @if (availableDocuments?.length > 0) {
      <div class="mb-1 history-label">
        Count ({{ pagination.count }})
      </div>
    }
    <div class="select-file-css">
      <label [for]="uniqueString" class="m-0" style="text-align: center;" (click)="onSelectFile($event)">
        <i class="upload-icon fa fa-upload kx-grey-txt-80"></i>
        <span>&nbsp;Select File</span>
      </label>
      <input
        type="file"
        [id]="uniqueString"
        (change)="onChange($event)"
        [multiple]="true"
        [accept]="'.jpg,.jpeg,.png'"
        style="display: none"
        />
    </div>
    @if (availableDocuments?.length > 0) {
      <div class="d-flex">
        <div
          class="_wf-buttonfornextprev _wf-buttonfornextprev2"
          [ngClass]="pagination.page_no === 0 ? 'errors' : ''"
          (click)="goPrev()"
          >
          <i class="fa fa-angle-left"></i> Previous
        </div>
        <div
          class="_wf-buttonfornextprev"
          [ngClass]="getClassToEnableDisableIcon()"
          (click)="goNext()"
          >
          Next <i class="fa fa-angle-right"></i>
        </div>
      </div>
    }
  </div>

  @if (availableDocuments?.length > 0) {
    <div class="overflow-auto text-nowrap px-4 my-4 table-responsive">
      @for (document of availableDocuments; track document) {
        <div
          class="text-center rounded imageContainer d-inline-block"
          (click)="loadHostedImage(document)"
          >
          <img
            [src]="document.imageUrl | secure | async"
            [alt]="document.documentName"
            width="120"
            height="120"
            />
        </div>
      }
    </div>
  }

  @if (selectedImages.length > 0 && isComponentArrayType) {
    <div class="overflow-auto text-nowrap mb-2 mt-2 table-responsive">
      <h3>Selected Documents</h3>
      <ul class="selctimageContainer"  (dragover)="onDragOverContainer($event)" (drop)="onDropInContainer($event)">
        @for (image of selectedImages; track image; let i = $index) {
          <li draggable="true" class="text-center rounded imageContainerselct d-inline-block" (click)="loadImageToEditor(image, false)"
            (dragstart)="onDragStart($event, i)"
            (dragover)="onDragOverItem($event, i)"
            (drop)="onDropOnItem($event, i)"
            (dragend)="onDragEnd($event)"
            >
            <img [src]="image.imageUrl | secure | async" [alt]="image.fileName || image.documentName" [width]="126" [height]="90" >
            <div class="sequence-badge">{{ i + 1 }}</div>
            <div class="selimgdelticon">
              <i class="fa fa-trash" (click)="deleteDoc(image, i)"></i>
            </div>
          </li>
        }
      </ul>
    </div>
  }
</div>

<div id="image-editor-container" style="height: 700px;"></div>